import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Sparkles } from 'lucide-react';
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraIcon } from './icon';
import { SpecraText } from './typography';
/**
 * Who made a change and how (FND-27 AWR-4): "<approver> via Specra Assist" for
 * a change a human accepted from an Assist proposal, the approver alone for a
 * direct change. Used by every version-history and History row.
 */ export const SpecraAssistAttribution = /*#__PURE__*/ React.forwardRef(({ approver, at, className, via, ...props }, ref)=>/*#__PURE__*/ _jsxs(SpecraText, {
        as: "span",
        className: cn('inline', className),
        "data-via": via || undefined,
        ref: ref,
        size: "caption",
        tone: "secondary",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "font-medium text-foreground",
                children: approver
            }),
            via === 'specra_assist' ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    ' ',
                    /*#__PURE__*/ _jsx(SpecraIcon, {
                        className: "align-middle text-info",
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(Sparkles, {})
                    }),
                    ' ',
                    "via Specra Assist"
                ]
            }) : null,
            at ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    ' · ',
                    at
                ]
            }) : null
        ]
    }));
SpecraAssistAttribution.displayName = 'SpecraAssistAttribution';
